import { Search, ShieldCheck, LayoutGrid, MessageCircle, Clock } from "lucide-react";
import SectionHead from "@/components/SectionHead";
import { useLang } from "@/i18n";

const ICONS = [Search, ShieldCheck, LayoutGrid, MessageCircle, Clock];

const WhyWebsite = () => {
  const t = useLang().t;
  return (
  <section id="why-website" data-testid="why-website" className="bg-[#FDFBF7] py-16 sm:py-24">
    <div className="container-site">
      <SectionHead
        testId="why-website-head"
        eyebrow={t.why.eyebrow}
        title={t.why.title}
        sub={t.why.sub}
      />
      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {t.why.cards.map((r, idx) => {
          const Icon = ICONS[idx];
          return (
          <div
            key={r.title}
            data-testid={`why-card-${idx}`}
            className={`card-site p-6 sm:p-8 ${idx === 0 ? "sm:col-span-2 lg:col-span-1" : ""}`}
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#F5F2EB]">
              <Icon className="h-6 w-6 text-[#A88667]" />
            </div>
            <h3 className="mt-5 font-heading text-lg sm:text-xl font-bold text-[#3E2723]">{r.title}</h3>
            <p className="mt-2 text-sm sm:text-base leading-relaxed text-[#5D4037]">{r.desc}</p>
          </div>
          );
        })}
      </div>
    </div>
  </section>
  );
};

export default WhyWebsite;
